import { reactWidget, hydrate } from './widget';
import { reactShinyInput } from './input';

window.reactR = {
  reactShinyInput: reactShinyInput,
  reactWidget: reactWidget,
  hydrate: hydrate
};
